import axios from "axios";
import { toast } from "react-toastify";
import store from "../Redux/Store";

export default class ApiService {
    static config = {

        baseUrl: 'https://abnocloud.com/genesis_unisol/api/',
        
        // baseUrl: 'https://abnocloud.com/genesis_ecommerce_portal/api/',
        
        getBusinessTokenApi: 'get-business-token'
    }

    static async request(method, url, dataOrParams = {}, value = false) {
        try {
            const token = store?.getState()?.userData?.access_token
            const headers = {
                'Content-Type': 'application/json',
            };

            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }

            if (dataOrParams instanceof FormData) {
                delete headers['Content-Type'];
            }

            const config = {
                method,
                // url: !value ? ApiService.config.baseUrl + url : ApiService.config.baseUrl + 'member/' + url,
                url: ApiService.config.baseUrl + 'ecommerce/' + url,
                headers: headers,
                timeout: 100000,
            };

            if (method === 'get' || method === 'delete') {
                config.params = dataOrParams;
            } else {
                config.data = dataOrParams;
            }

            const response = await axios(config);
            return response.data;
        } catch (error) {
            ApiService.handleError(error);
        }
    }

    static handleError(error) {
        if (error.response) {
            const errorData = error.response.data;
            toast.error(errorData.message || "Failed to process");
        } else if (error.request) {
            toast.error("No response received from server");
        } else if (error.code === 'ECONNABORTED') {
            toast.error("Request timed out");
        } else {
            toast.error("Failed to process");
        }
        console.error("API call failed:", error);
        throw error;
    }

    // Call api by some perticular methods also
    // static async get(url, params = {}) {
    //     try {
    //         const response = await axios.get(ApiService.config.url + url, {
    //             params,
    //         });
    //         return response.data;
    //     } catch (error) {
    //         ApiService.handleError(error);
    //     }
    // }

    // static async post(url, data = {}) {
    //     try {
    //         const headers = {
    //             'Content-Type': 'application/json',
    //         };

    //         // Add Authorization header if token is available
    //         // if (token) {
    //         //     headers['Authorization'] = `Bearer ${token}`;
    //         // }
    //         const response = await axios.post(ApiService.config.url + url, data, {
    //             headers: headers,
    //             timeout: ApiService.config.timeout,
    //         });
    //         return response.data;
    //     } catch (error) {
    //         ApiService.handleError(error);
    //     }
    // }

}